import { check } from "../../config/Config";
import ErrorHandler from "./errorHandler";
import axios from "axios";
import {
  createArrayEntityFromObject,
  createQueryUrl,
  getEntity,
} from "../../config/global";
import { openErrorPage } from "../../config/AndroidBridge";
const baseUrlDev = check();
const PSP_MOBILE_FEATURE_ID = "6a322ea1adf0233a1d1d9ad4";
const PSP_MOBILE_FEATURE_STORAGE_KEY = "psp-mobile-feature";
const bearer = () => {
  return localStorage.getItem("token_redux").replaceAll('"', "");
};
export const checkCompany = (initial) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}user/member/company`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        ErrorHandler(err);
        reject(err);
      });
  });
};

export const login = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${baseUrlDev}katalis/login`, data, {})
      .then((res) => {
        localStorage.setItem("name", res.data.user.name);
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        reject(err);
      });
  });
};
export const confirmasi_email = (query) => {
  let url = `${baseUrlDev}mob_user/confirm_email?email=${query.email}`;
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${url}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage
              .getItem("token_redux")
              .replaceAll('"', "")}`,
          },
        },
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const confirmasi_otp = (query) => {
  let url = `${baseUrlDev}mob_user/validation_email?${createQueryUrl(
    getEntity(createArrayEntityFromObject(query), query),
    "&",
  )}`;
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${url}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage
              .getItem("token_redux")
              .replaceAll('"', "")}`,
          },
        },
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const confirmation_otp_login = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${baseUrlDev}mob_user/otp_login`, data, {
        headers: {},
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const credentialCheck = (token = bearer()) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}katalis/user/credential/check`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        localStorage.setItem("company", JSON.stringify(res.data.activeCompany));
        localStorage.setItem("tags", JSON.stringify(res.data.tags));
        getFeatureById()
          .then((featureRes) => {
            localStorage.setItem(
              PSP_MOBILE_FEATURE_STORAGE_KEY,
              JSON.stringify(featureRes.data)
            );
          })
          .catch(() => {
            localStorage.removeItem(PSP_MOBILE_FEATURE_STORAGE_KEY);
          });
        resolve(res);
      })
      .catch((err) => {
        console.log(err);
        if (err?.response?.data?.status == 400) {
          let msg = String(err?.response?.data?.message).replace(" **", "");
          let name = localStorage.getItem("name");
          if (msg.includes("Institusi tidak aktif")) {
            localStorage.getItem("app_version")
              ? openErrorPage(name, msg)
              : window.location.replace(`/inactive/${name}/${msg}`);
            return;
          }
          if (
            msg.includes("ALUMNI") ||
            msg.includes("BLOKIR") ||
            msg.includes("KELUAR") ||
            msg.includes("BLOCK_USER") ||
            String(err?.response?.data?.message).slice(-2) == "**"
          ) {
            let newmsg = "BLOCK_USER";
            localStorage.getItem("app_version")
              ? openErrorPage(name, newmsg)
              : window.location.replace(`/inactive/${name}/${newmsg}`);
            return;
          }
        }
        reject(err);
      });
  });
};

export const getFeatureById = (id = { id: PSP_MOBILE_FEATURE_ID }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}auth-support/feature/${id.id}`, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const cekToken = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}user/member/profile`, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getCustomApps = (companyId, lang) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${baseUrlDev}main_a/web_view/custom_apps/mobile/${companyId}?lang=${lang}&app=webview`,
        {},
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getIconApps = (companyId, icon) => {
  https: return new Promise((resolve, reject) => {
    axios
      .get(
        `${baseUrlDev}main_a/web_view/custom_apps/icon/${companyId}/${icon}`,
        {},
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
export const logout = () => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}api_default/auth/logout`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const inputOtp = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${baseUrlDev}mob_user/forgot_password/user_membership_member/${data.otp}`,
        data,
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createPassword = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${baseUrlDev}api_default/auth/user_change_password_first_login/user_membership_member`,
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage
              .getItem("token_redux")
              .replaceAll('"', "")}`,
          },
        },
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const createSecurityCode = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${baseUrlDev}mob_user/security_code`, data, {
        headers: {
          Authorization: `Bearer ${localStorage
            .getItem("token_redux")
            .replaceAll('"', "")}`,
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getConfigSelfRegister = (companyId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}mob_user/get_config_self_register/${companyId}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const resend_otp = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(
        `${baseUrlDev}mob_user/get_otp/user_membership_member?email=${data.email}&companyId=${data.companyId}`,
      )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const requestOtpSelfRegister = (query) => {
  let url = `${baseUrlDev}mob_user/request_otp_self_register?${createQueryUrl(
    getEntity(createArrayEntityFromObject(query), query),
    "&",
  )}`;
  return new Promise((resolve, reject) => {
    axios
      .post(url)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const selfRegister = (query, data) => {
  let url = `${baseUrlDev}mob_user/send_self_registration_data?${createQueryUrl(
    getEntity(createArrayEntityFromObject(query), query),
    "&",
  )}`;
  return new Promise((resolve, reject) => {
    axios
      .post(url, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getFaq = (category, lang, tag) => {
  let url = `${baseUrlDev}main_a/general/my_faq?category=${category}&lang=${lang}&tag=${tag}`;
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
